/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Events_EmptyInputs */

const cs_portals_events_empty = /** @type {(inputs: Portals_Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné události publikace na portálech.`)
};

const en_portals_events_empty = /** @type {(inputs: Portals_Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No portal publication events yet.`)
};

/**
* | output |
* | --- |
* | "No portal publication events yet." |
*
* @param {Portals_Events_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_events_empty = /** @type {((inputs?: Portals_Events_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Events_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_events_empty(inputs)
	return cs_portals_events_empty(inputs)
});